export default __webpack_public_path__ + "static/media/poppy_results_bg-mobile.png";